import { Dispatch } from "redux";
import { setTickets } from "src/redux/actions/workRequest";
import { FirebaseDataService, Response } from "src/services/Firebase/data";
import { Ticket } from "src/types";
import { ActiveEmployee, AssignWOResourceFormValues } from "../AssignWOResource/types";

export const onAssignResourceHandler = async (
  workOrder: AssignWOResourceFormValues,
  setAssignResourceErrorOnSubmit: React.Dispatch<React.SetStateAction<string>>,
  tickets: Ticket[],
  employees: ActiveEmployee[],
  dispatch: Dispatch,
  userId: string,
  workOrderId: string,
  setSelectedTicketForAssignResource: React.Dispatch<React.SetStateAction<Ticket | undefined>>,
) => {
  setAssignResourceErrorOnSubmit("");

  try {
    const selectedTicket = tickets.find((ticket) => ticket.wonum === workOrderId);
    const selectedEmployee = employees.find((employee) => employee.laborCode === workOrder.employees.laborCode);
    const res = await onSubmitAssignResourceHandler(workOrder, workOrderId, userId, selectedEmployee);

    if (res && res.status === "success") {
      const updatedTickets = tickets.map((ticket) => {
        if (ticket.wonum === workOrderId) {
          const updatedTicket = { ...ticket };

          updatedTicket["vendorId"] = workOrder.vendors.vendorId;
          updatedTicket["laborId"] = workOrder.employees.laborCode;
          updatedTicket["assignedResourceName"] =
            workOrder.vendors.vendorName || selectedEmployee?.displayName || workOrder.employees.laborCode || "";
          updatedTicket["assignedEmployeeEmail"] = selectedEmployee?.email || "";
          updatedTicket["woacceptscharges"] = workOrder.vendors.woacceptscharges;
          updatedTicket["approvedamount"] = workOrder.vendors.approvedamount;
          return updatedTicket;
        }
        return ticket;
      });

      dispatch(setTickets(updatedTickets));
      if (selectedEmployee?.email) {
        const subject = `Work Order ${workOrderId}: ${selectedTicket?.description || "Work Request"}`;
        const message = [
          `Work Order: ${workOrderId}`,
          `Title: ${selectedTicket?.description || "N/A"}`,
          `Location: ${selectedTicket?.location || "N/A"}`,
          `Priority: ${selectedTicket?.priority || "N/A"}`,
          `Status: ${selectedTicket?.statusDescription || selectedTicket?.status || "N/A"}`,
          `Assigned Resource: ${selectedEmployee.displayName || selectedEmployee.laborCode || "N/A"}`,
          "",
          "Please proceed with the required work and update progress in the portal.",
        ].join("\n");

        const query = new URLSearchParams();
        query.set("subject", subject);
        query.set("body", message);
        window.location.href = `mailto:${selectedEmployee.email}?${query.toString()}`;
      }
      setSelectedTicketForAssignResource(undefined);
    } else {
      setAssignResourceErrorOnSubmit(res?.message ?? "An error occurred");
    }
  } catch (error) {
    setAssignResourceErrorOnSubmit(`An error occurred while assigning resources: ${error}`);
  }
};

const onSubmitAssignResourceHandler = async (
  data: AssignWOResourceFormValues,
  workOrderId: string,
  managerId: string,
  selectedEmployee?: ActiveEmployee,
): Promise<Response | undefined> => {
  if (workOrderId) {
    return FirebaseDataService.assignResourceInWorkOrder({
      wonum: workOrderId,
      approvedamount: data.vendors.approvedamount,
      vendorId: data.vendors.vendorId,
      vendorName: data.vendors.vendorName,
      woacceptscharges: data.vendors.woacceptscharges,
      laborCode: data.employees.laborCode,
      managerId,
      assignedEmployee: selectedEmployee
        ? {
            id: selectedEmployee.id,
            laborCode: selectedEmployee.laborCode,
            displayName: selectedEmployee.displayName,
            email: selectedEmployee.email,
          }
        : undefined,
    });
  }
};
